// extracted by mini-css-extract-plugin
export var planCard = "_vr-0";
export var planList = "_vr-1";